<script>
  import { onDestroy, onMount, createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
	const close = () => dispatch('close');

  let dialogWrapper;
  let platformShareLinks;
  let linkShare;
  let linkShareInput;
  let linkshareConfirmation;
  let linkTemplates;

  function init() {
    dialogWrapper = document.querySelector("#labshare");
    platformShareLinks = dialogWrapper.querySelectorAll("a.labshare-button");
    linkShare = dialogWrapper.querySelector(".labshare-clipboard");
    linkShareInput = linkShare.querySelector("input");
    linkshareConfirmation = dialogWrapper.querySelector("#labshare-clipboard-confirm");

    dialogWrapper.querySelector("button.close").addEventListener("click", closeDialog);
    dialogWrapper.querySelector(".labshare-background").addEventListener("click", closeDialog);
    linkShare.addEventListener("click", copyLinkToClipboard);
    
    linkTemplates = {};
    platformShareLinks.forEach(link => {
      // We save the initial 'href's from the platform links. We'll use those as templates for
      // creating the final links when updating the popup info (title, text and url)
      linkTemplates[link.id] = link.href.replace(/%20/g, "");
      // set up the popup-opening logic
      link.addEventListener('click', e => {
        if (link.dataset.type === "link") return;
        else {
          e.preventDefault();
          const width = parseInt(link.dataset.width);
          const height = parseInt(link.dataset.height);
          popup(link.href, width, height);
        }
      });
    });
  }

  /**
   * Copies the current value of the 'linkShare' element to the clipboard, and displays a
   * confirmation dialog to the user
   */
  function copyLinkToClipboard() {
    linkShareInput.select();
    linkShareInput.setSelectionRange(0, linkShareInput.value.length); /*For mobile devices*/
    const success = document.execCommand("copy");
    
    if (success) {
      linkshareConfirmation.textContent = "Link copied to clipboard"
      linkshareConfirmation.classList.add("active");
      setTimeout(()=>{
        linkshareConfirmation.classList.remove("active");
      }, 8000);
    }
  }

  /**
   * @param {Object} options
   * @property {string} options.url - Url to share
   * @property {string} options.title - Short description of the experiment
   * @property {string} options.text - description of the experiment, including hashtags, mentions, etc...
   */
  async function openDialog({url=null, text="", title=""}) {
    // Native sharing on safari desktop is terrible. We'll disable it and use our custom dialog.
    // Thanks karo, for the safari detection.
    const isSafari = /Safari/i.test(navigator.userAgent)
      && /Apple Computer/.test(navigator.vendor)
      && !/Mobi|Android/i.test(navigator.userAgent);

      // Native sharing is slightly broken on IOS (mail subject is not set)
    // const isIOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
      
    if (navigator.share && !isSafari) {
      try {
        await navigator.share({ url, text, title });
      }
      catch(err) {
        //console.log("share cancelled");
      }
      close();
    } else {
      // update links
      platformShareLinks.forEach(link => {
        const template = linkTemplates[link.id];
        let newHref = template;
        newHref = newHref.replace(/%url%/g, encodeURIComponent(url));
        newHref = newHref.replace(/%text%/g, encodeURIComponent(text));
        newHref = newHref.replace(/%title%/g, encodeURIComponent(title));
        link.href = newHref;
      });
      linkShareInput.value = url;
  
      // open dialog
      dialogWrapper.classList.add("open");
      // listen for esc key
      window.addEventListener('keyup', onKey);
    }
  }
  function onKey(e) {
    if (e.key === "Escape") closeDialog();
  }
  function closeDialog() {
    window.removeEventListener('keyup', onKey);
    dialogWrapper.classList.remove("open");
    close();
  }
  
  /**
   * Opens a popup positionned in the center of the current window
   * @param {*} url - The url to open
   * @param {*} width - The width of the popup
   * @param {*} height - The width of the popup
   */
  function popup(url, width, height) {
    const left = Math.floor((window.innerWidth - width) * .5);
    const top = Math.floor((window.innerHeight - height) * .5);
    window.open(url, '',
      'top=' + top + ',left=' + left + ',width=' + width +
      ',height=' + height + ',menubar=no,scrollbars=no,statusbar=no'
    );
  }

  onMount(() => { 
    init();
    openDialog({
      url: 'https://experiments.withgoogle.com/nonsense-laboratory',
      title: 'Nonsense Laboratory',
      text: 'The Nonsense Laboratory uses machine learning to let you poke at, mangle, and play with the spelling of words.'
    });
  });

  onDestroy(() => {
    closeDialog();
  });

</script>

<style>
  
  /* reset */
  #labshare * {
    box-sizing: border-box;
    line-height: inherit;
  }
  #labshare button {
    border: none;
    background-color: transparent;
  }
  #labshare div {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  #labshare h2 {
    font-size: 22px;
    margin: 0;
    line-height: 1;
    font-weight: normal;
    text-transform: none;
  }
  /* reset - end */

  #labshare {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 2000;
    position: absolute;
    top: 0;
    left: 0;
    font-family: 'Roboto', 'Helvetica', sans-serif;
  }

  .labshare-background {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.137);
    width: 100%;
    height: 100%;
  }
  #labshare:not(.open) {
    display: none;
  }

  .labshare-dialog {
    position: relative;
    background-color: white;
    min-height: 290px;
    width: 282px;
    flex-shrink: 0;
    border-radius: 2px;
    max-height: calc(100% - 50px);
    display: flex;
    flex-direction: column;
  }
  #labshare header {
    display: flex;
    padding: 24px 24px 20px 24px;

    justify-content: space-between;
    align-items: center;

    font-family: 'Google Sans', Roboto, Arial, sans-serif;
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 1.75rem;
  }
  #labshare .labshare-dialog .content {
    padding: 24px;
    padding-top: 0;
    margin-top: 12px;
    overflow-y: auto;
    font-size: 0;
  }
  .labshare-button {
    font-size: 14px;
    margin-top: 8px;
    text-decoration: none;
    display: inline-block;
    width: calc(33.33333333% - 16px);
    margin-bottom: 24px;
    text-align: center;
    box-sizing: border-box;
    color: inherit;
  }

  .labshare-button:nth-child(3n+1) {
    margin-right: 12px;
  }
  .labshare-button:nth-child(3n+2) {
    margin-left: 12px;
    margin-right: 12px;
  }
  .labshare-button:nth-child(3n+3) {
    margin-left: 12px;
  }

  .labshare-button span,
  .labshare-button svg {
    display: inline-block;
  }
  .labshare-button span{
    width: 62px;
    margin-top: 8px;
    line-height: 1;
  }
  .labshare-button svg {
    height: 60px;
    width: 60px;
  }

  .labshare-clipboard input {
    background-color: #f1f3f4;
    border: none;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    color: #4285f4;
    cursor: pointer;
    direction: rtl;
    font-size: 16px;
    margin-top: 24px;
    padding: 18px 24px;
    text-align: center;
    width: 100%;
  }
  .labshare-clipboard input:focus {
    background: #4285f4;
    color: #fff;
    outline: none;
  }

  .labshare-clipboard-tip {
    color: #5f6368;
    display: block;
    font-size: 12px;
    margin-top: 8px;
    text-align: center;
  }

  #labshare #labshare-clipboard-confirm {
    background-color: #4285f4;
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 14px 24px;
  }
  #labshare #labshare-clipboard-confirm:not(.active) {
    display: none;
  }

  @media screen and (min-width: 481px) {
    #labshare #labshare-clipboard-confirm {
      bottom: 24px;
      left: 24px;
      border-radius: 2px;
      width: unset;
      box-shadow: 0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12), 0 3px 5px -1px rgba(0,0,0,0.2);
    }
  }
</style>

<div class="dialog-wrap" id="labshare">
  <div class="labshare-background"></div>

  <div class="labshare-dialog">
    <header>
      <h2>Share</h2>
      <button class="close mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
      </button>
    </header>

    <div class="content">
      <a id="facebook-button" class="labshare-button"
         href="https://www.facebook.com/sharer.php?u=%url%"
         data-width="520" data-height="400" data-type="popup"
         target="_blank" aria-label="Share on Facebook">
        <svg width="60px" height="60px" viewBox="0 0 60 60" class="uqdzed"><g fill="none" fill-rule="evenodd"><path d="M28.486 59.97c-6.636-.57-11.563-2.328-16.322-5.825C4.444 48.472 0 39.647 0 29.987 0 15.112 10.507 2.798 25.274.367c6.029-.992 12.704.05 18.288 2.854 13.577 6.818 19.782 22.54 14.643 37.103-3.528 9.998-12.79 17.618-23.391 19.245-2.086.32-5.065.509-6.328.4z" fill="#3B5998" fill-rule="nonzero"></path><path d="M25.73 45h5.459V30.007h4.095l.81-4.684h-4.905v-3.395c0-1.094.707-2.243 1.719-2.243h2.787V15H32.28v.021c-5.345.194-6.443 3.29-6.538 6.541h-.01v3.76H23v4.685h2.73V45z" fill="#FFF"></path></g></svg>
        <span>Facebook</span>
      </a>
      <a id="twitter-button" class="labshare-button"
         href="https://twitter.com/intent/tweet?url=%url%&text=%text%&via=googlearts"
         data-width="520" data-height="400" data-type="popup"
         target="_blank" aria-label="Share on Twitter">
        <svg width="60px" height="60px" viewBox="0 0 60 60" class="uqdzed"><g fill="none" fill-rule="evenodd"><path d="M28.486 59.97c-6.636-.57-11.563-2.328-16.322-5.825C4.444 48.472 0 39.647 0 29.987 0 15.112 10.507 2.798 25.274.367c6.029-.992 12.704.05 18.288 2.854 13.577 6.818 19.782 22.54 14.643 37.103-3.528 9.998-12.79 17.618-23.391 19.245-2.086.32-5.065.509-6.328.4z" fill="#1DA1F2" fill-rule="nonzero"></path><path d="M45.09 17.577c-.93.596-3.065 1.461-4.118 1.461v.002a6.602 6.602 0 0 0-11.206 6.034h-.001c-4.945-.13-10.354-2.608-13.61-6.85-2.001 3.464-.27 7.318 2.003 8.722-.778.059-2.21-.09-2.883-.747-.045 2.3 1.06 5.347 5.092 6.452-.776.418-2.15.298-2.749.21.21 1.94 2.929 4.479 5.902 4.479-1.06 1.225-5.046 3.448-9.52 2.74C17.038 41.93 20.58 43 24.327 43c10.65 0 18.922-8.632 18.477-19.28-.002-.012-.002-.024-.003-.037.001-.027.003-.054.003-.083 0-.033-.003-.064-.004-.096.97-.663 2.27-1.836 3.2-3.38-.539.297-2.156.891-3.66 1.039.965-.521 2.396-2.228 2.75-3.586" fill="#FFF"></path></g></svg>
        <span>Twitter</span>
      </a>
      <a id="pinterest-button" class="labshare-button"
         href="https://pinterest.com/pin/create/bookmarklet?url=%url%&description=%text%"
         data-width="660" data-height="400" data-type="popup"
         target="_blank" aria-label="Share on Pinterest">
        <svg width="60px" height="60px" viewBox="0 0 60 60" class="uqdzed"><g fill="none" fill-rule="evenodd"><path d="M28.486 59.97c-6.636-.57-11.563-2.328-16.322-5.825C4.444 48.472 0 39.647 0 29.987 0 15.112 10.507 2.798 25.274.367c6.029-.992 12.704.05 18.288 2.854 13.577 6.818 19.782 22.54 14.643 37.103-3.528 9.998-12.79 17.618-23.391 19.245-2.086.32-5.065.509-6.328.4z" fill="#BD081C" fill-rule="nonzero"></path><path d="M30 14c-8.836 0-16 7.171-16 16.017 0 6.592 3.98 12.254 9.665 14.713-.04-1.116-.001-2.448.281-3.655.31-1.303 2.069-8.76 2.069-8.76s-.514-1.027-.514-2.544c0-2.38 1.38-4.16 3.097-4.16 1.46 0 2.167 1.1 2.167 2.415 0 1.47-.937 3.667-1.42 5.702-.4 1.705.857 3.097 2.537 3.097 3.04 0 5.088-3.91 5.088-8.548 0-3.52-2.367-6.16-6.68-6.16-4.87 0-7.907 3.637-7.907 7.7 0 1.4.414 2.39 1.061 3.153.297.35.337.493.229.897-.078.294-.251 1.006-.325 1.29-.107.407-.438.55-.805.4-2.242-.915-3.289-3.374-3.289-6.139 0-4.567 3.848-10.042 11.477-10.042 6.132 0 10.166 4.442 10.166 9.207 0 6.309-3.503 11.017-8.664 11.017-1.734 0-3.366-.938-3.922-2.002 0 0-.935 3.7-1.13 4.418-.337 1.221-.987 2.441-1.588 3.402a16 16 0 0 0 4.407.615c8.836 0 16-7.171 16-16.016C46 21.17 38.836 14 30 14" fill="#FFF"></path></g></svg>
        <span>Pinterest</span>
      </a>
      <a id="email-button" class="labshare-button"
         href="mailto:?subject=%text%&body=%url%"
         data-type="link"
         target="_blank" aria-label="Share via Email">
        <svg width="60px" height="60px" viewBox="0 0 60 60" fill="#757575" class="uqdzed"><g fill-rule="nonzero" fill="none"><path d="M28.486 59.97c-6.636-.57-11.563-2.328-16.322-5.825C4.444 48.472 0 39.647 0 29.987 0 15.112 10.507 2.798 25.274.367c6.029-.992 12.704.05 18.288 2.854 13.577 6.818 19.782 22.54 14.643 37.103-3.528 9.998-12.79 17.618-23.391 19.245-2.086.32-5.065.509-6.328.4z" fill="#888"></path><path d="M41 19H19c-1.74 0-2.986 1.238-3 3v16c0 1.762 1.26 3 3 3h22c1.74 0 3-1.238 3-3V22c0-1.762-1.26-3-3-3zm0 6l-11 7-11-7v-3l11 7 11-7v3z" fill="#FFF"></path></g></svg>
        <span>E-mail</span>
      </a>
      <a id="tumblr-button" class="labshare-button"
         href="https://www.tumblr.com/widgets/share/tool?canonicalUrl=%url%"
         data-width="520" data-height="400" data-type="popup"
         target="_blank" aria-label="Share on Tumblr">
        <svg width="60px" height="60px" viewBox="0 0 60 60" class="uqdzed"><g fill="none" fill-rule="evenodd"><path d="M28.486 59.97c-6.636-.57-11.563-2.328-16.322-5.825C4.444 48.472 0 39.647 0 29.987 0 15.112 10.507 2.798 25.274.367c6.029-.992 12.704.05 18.288 2.854 13.577 6.818 19.782 22.54 14.643 37.103-3.528 9.998-12.79 17.618-23.391 19.245-2.086.32-5.065.509-6.328.4z" fill="#35465C" fill-rule="nonzero"></path><path d="M25.965 14c0 6.948-5.965 8.207-5.965 8.207v4.75h4.023v11.789c0 3.962 3.654 7.254 8.098 7.254 4.445 0 6.883-1.769 6.883-1.769v-5.24s-1.342 1.767-4.082 1.767c-2.74 0-3.925-2.133-3.925-3.778v-9.993h7.004v-5.025h-7.004V14h-5.032z" fill="#FFF"></path></g></svg>
        <span>Tumblr</span>
      </a>
      <a id="vkontakte-button" class="labshare-button"
         href="https://vk.com/share.php?url=%url%&title=%text%"
         data-width="520" data-height="400" data-type="popup"
         target="_blank" aria-label="Share on VKontacte">
        <svg width="60px" height="60px" viewBox="0 0 60 60" class="uqdzed"><path d="M28.5 60c-6.6-.6-11.6-2.3-16.3-5.8C4.4 48.5 0 39.6 0 30 0 15.1 10.5 2.8 25.3.4c6-1 12.7 0 18.3 2.9 13.5 6.7 19.7 22.5 14.6 37-3.5 10-12.8 17.6-23.4 19.2-2.1.4-5.1.6-6.3.5z" fill="#5181b8"></path><path d="M45.9 21.4c.2-.8 0-1.3-1.1-1.3h-3.6c-.9 0-1.4.5-1.6 1 0 0-1.9 4.5-4.5 7.5-.8.8-1.2 1.1-1.7 1.1-.2 0-.6-.3-.6-1v-7.2c0-.9-.3-1.3-1-1.3H26c-.6 0-.9.4-.9.8 0 .9 1.3 1.1 1.4 3.6V30c0 1.2-.2 1.4-.7 1.4-1.2 0-4.2-4.5-6-9.7-.3-1-.7-1.4-1.6-1.4h-3.6c-1 0-1.3.5-1.3 1 0 1 1.2 5.8 5.8 12.1 3 4.3 7.3 6.7 11.1 6.7 2.3 0 2.6-.5 2.6-1.4v-3.3c0-1 .2-1.2 1-1.2.5 0 1.5.3 3.6 2.4 2.5 2.5 2.9 3.6 4.3 3.6h3.6c1 0 1.6-.5 1.3-1.5-.3-1-1.5-2.5-3.1-4.3-.8-1-2.1-2.1-2.5-2.6-.5-.7-.4-1 0-1.6 0-.4 4.4-6.6 4.9-8.8z" fill="#fff"></path></svg>
        <span>VKontakte</span>
      </a>
      <a id="classroom-button" class="labshare-button"
         href="https://classroom.google.com/u/0/share?url=%url%&title=%text%"
         data-width="520" data-height="400" data-type="popup"
         target="_blank" aria-label="Share on Classroom">
        <svg width="48px" height="48px" viewBox="0 0 48 48" fill="#757575" class="uqdzed"><path fill="none" d="M0 0h48v48H0z"></path><circle fill="#F4F4F4" cx="24" cy="24" r="22"></circle><circle fill="none" cx="24" cy="24" r="22"></circle><path fill="#FFF" fill-opacity=".2" d="M24 2.23c12.11 0 21.94 9.79 22 21.89v-.11c0-12.15-9.85-22-22-22S2 11.85 2 24v.11c.06-12.09 9.89-21.88 22-21.88z"></path><path fill="#263238" fill-opacity=".2" d="M46 23.89c-.06 12.1-9.89 21.89-22 21.89S2.06 35.99 2 23.89V24c0 12.15 9.85 22 22 22s22-9.85 22-22v-.11z"></path><circle fill="none" cx="24" cy="24" r="22"></circle><defs><path id="a" d="M36.11 12.02H11.89c-1.05 0-1.89.87-1.89 1.92v20.21c0 1.05.85 1.89 1.89 1.83H36.1c1.05.07 1.9-.78 1.9-1.82V13.94c0-1.04-.85-1.92-1.89-1.92z"></path></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"></use></clipPath><g clip-path="url(#b)"><path fill="#0F9D58" d="M12 14h24v20H12V14z"></path><path fill="#57BB8A" d="M29.05 23.59c.78 0 1.42-.64 1.42-1.42s-.64-1.42-1.42-1.42c-.78 0-1.42.64-1.42 1.42s.64 1.42 1.42 1.42zm0 .99c-1.52 0-3.16.81-3.16 1.8V28h6.32v-1.62c0-.99-1.64-1.8-3.16-1.8zm-10.1-.99c.78 0 1.42-.64 1.42-1.42s-.64-1.42-1.42-1.42a1.419 1.419 0 1 0 0 2.84zm0 .99c-1.52 0-3.16.81-3.16 1.8V28h6.32v-1.62c0-.99-1.64-1.8-3.16-1.8z"></path><path fill="#F7F7F7" d="M24 22c1.05 0 1.89-.81 1.89-1.86s-.85-1.89-1.89-1.89c-1.05 0-1.9.85-1.9 1.89.01 1.05.85 1.86 1.9 1.86zm0 2c-1.89 0-4 .76-4 2.16V28h8v-1.84c0-1.4-2.11-2.16-4-2.16z"></path><path fill="#F1F1F1" d="M26 32h7v2.1h-7V32z"></path><path fill="#F4B400" d="M36.11 12.02H11.89c-1.05 0-1.89.87-1.89 1.92v20.21c0 1.05.85 1.89 1.89 1.83H36.1c1.05.07 1.9-.78 1.9-1.82V13.94c0-1.04-.85-1.92-1.89-1.92zM36 34H12V14h24v20z"></path><path opacity=".2" fill="#FFF" d="M36.11 12.02H11.89c-1.05 0-1.89.87-1.89 1.92v.16c0-1.05.85-1.92 1.89-1.92H36.1c1.05 0 1.89.87 1.89 1.92v-.16c.01-1.04-.84-1.92-1.88-1.92z"></path><path opacity=".2" fill="#BF360C" d="M36.11 35.83H11.89C10.85 35.89 10 35.04 10 34v.16c0 1.05.85 1.89 1.89 1.83H36.1c1.05.06 1.9-.79 1.9-1.83V34c0 1.04-.85 1.89-1.89 1.83z"></path><linearGradient id="c" gradientUnits="userSpaceOnUse" x1="2155" y1="-6746.342" x2="2155" y2="-6762.287" gradientTransform="matrix(.125 0 0 -.125 -238.875 -809.265)"><stop offset="0" stop-color="#bf360c" stop-opacity=".2"></stop><stop offset="1" stop-color="#bf360c" stop-opacity=".02"></stop></linearGradient><path fill="url(#c)" d="M33 34h-7l2 2h7l-2-2z"></path><path opacity=".2" fill="#263238" d="M12 14h24v-.2H12v.2z"></path></g><path opacity=".2" fill="#FFF" d="M12.03 34H36v.25H12.03V34z"></path><radialGradient id="d" cx="110.341" cy="148.159" r="47.683" gradientTransform="translate(-92.5 -127.167) scale(.9167)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"></stop><stop offset="1" stop-color="#fff" stop-opacity="0"></stop></radialGradient><circle fill="url(#d)" fill-opacity=".1" cx="24" cy="24" r="22"></circle></svg>
        <span>Classroom</span>
      </a>

      <div class="labshare-clipboard">
        <input type="text" value="https://g.co/arts/uqgU3evoST1DHSJ59" class="fgVQo" readonly="">
        <span class="labshare-clipboard-tip">Tap to copy the link</span>
      </div>
    </div>
  </div>
  <div id="labshare-clipboard-confirm">Link copied to clipboard</div>
</div>